<template>
    <div class="wrap-content">
        <!-- <p class="title-logo">MetalX</p> -->
        <img src="../assets/abi-vertical.png" alt="" class="img-title" />
        <div class="content-left">
            <router-link to="/login" class="route-back">Back</router-link>
        </div>
        <div class="content-right">
            <p class="brand">Reset password</p>
            <form @submit.prevent="resetPassword">
                <div class="form-group">
                    <input type="text" class="form-input" placeholder="Masukkan alamat email anda" v-model.trim="$v.email.$model" />
                    <p class="notice">
                        masukkan email yang digunakan untuk mendaftar sebelumnya
                    </p>
                </div>
                <div v-if="$v.email.$error">
                    <div class="error" v-if="!$v.email.required">
                        Email tidak boleh kosong
                    </div>
                    <div class="error" v-if="!$v.email.email">Format email salah</div>
                </div>
                <p class="succes" v-if="status == 200">
                    Silahkan cek email untuk mendapatkan link konfirmasi
                </p>
                <p class="error" v-else-if="status == 404">
                    Email yang anda masukkan salah
                </p>
                <button class="btn-primer">
                    <span v-show="!isLoading">Reset</span>
                    <b-spinner label="Loading..." v-show="isLoading" variant="light"></b-spinner>
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
export default {
    data() {
        return {
            email: "",
            status: "",
            isLoading: false,
        };
    },
    validations: {
        email: {
            required,
            email,
        },
    },
    methods: {
        resetPassword() {
            this.$v.email.$touch();
            if (this.$v.email.$error) {
                return;
            }

            this.isLoading = true;
            this.$store
                .dispatch("resetpassword", { email: this.email })
                .then((res) => {
                    this.isLoading = false;
                    this.status = res.status;
                    // console.log(res)
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.status = error.response.status;
                    this.$toast.error(error.response.data.data.err_message);
                });
        },
    },
    computed: {
        response() {
            let status = this.$store.getters.status;
            if (status == 200) {
                return "Silahkan cek email untuk melakukan mendapatkan link";
            } else if (status == 404) {
                return "Email salah";
            } else {
                return null;
            }
        },
    },
};
</script>

<style scoped>
.wrap-content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    flex-direction: column;
    background: rgba(197, 151, 51, 0.4);
}

.title-logo {
    position: relative;
    top: -30px;
    font-size: 45px;
    font-weight: bold;
    color: #1e354a;
}

.img-title {
    height: 98px;
    margin-bottom: 40px;
}

.content-left {
    width: 43%;
    height: 40px;
    background: #1e354a;
    border-radius: 5px 5px 0 0;
    color: #ffffff;
    padding: 5px 20px;
    box-shadow: 0px 8px 20px 0px rgb(0 0 0 / 15%);
}

.route-back {
    text-decoration: none;
    color: #fff;
    line-height: 2.5;
    font-size: 13px;
}

.route-back:hover {
    color: #c59733;
}

.content-right {
    width: 46%;
    background: white;
    padding: 25px 45px;
    border-radius: 5px;
    box-shadow: 0px 8px 20px 0px rgb(0 0 0 / 15%);
}

.form-input {
    width: 100%;
    height: 50px;
}

.brand {
    font-size: 25px;
    font-weight: bold;
    margin: 0 0 43px;
}

.notice {
    font-size: 12px;
    font-weight: bold;
    color: rgba(112, 112, 112, 0.7);
}

@media (min-width: 720px) and (max-width: 1024px) {
    .hello {
        flex-wrap: wrap;
    }

    .content-left {
        text-align: center;
    }

    .content-right {
        margin: -100px 0 0 0;
    }

    .btn-primer {
        width: 225px;
        display: block;
        margin: 40px auto;
    }

    .have-account {
        text-align: center;
    }
}

@media (max-width: 768px) {
    .brand {
        margin-bottom: 26px;
    }
    .content-left {
        width: 80%;
    }

    .content-right {
        width: 90%;
        padding: 1rem 1.5rem;
    }

    .img-title {
        height: 4rem;
    }
}
</style>
